import { Card } from "@components/cards/card";
import { InfrastructureListItem } from "@hooks/dtos/IInfrastructureDTO";
import { getInfrastructureStatusInfo } from "@hooks/functions/Infrastructure";
import { Masks } from "@hooks/functions/Masks/Masks";
import { FiMoreHorizontal } from "react-icons/fi";

interface IProps {
  infrastructures: InfrastructureListItem[];
}

const masks = new Masks();
const emptyValue = "-";

const formatGb = (value?: number) =>
  value || value === 0 ? `${masks.formatMilhar(value)} GB` : emptyValue;

const getBadgeTextClass = (variant: string) =>
  variant === "warning" || variant === "info" ? "text-dark" : "text-white";

export function InfrastructureTable({ infrastructures }: IProps) {
  return (
    <Card className="border-0 shadow-sm">
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Nome</th>
              <th>Tipo</th>
              <th>IP principal</th>
              <th>vCPU</th>
              <th>RAM / Swap</th>
              <th>Disco</th>
              <th>Host</th>
              <th>Status</th>
              <th className="text-end">Ações</th>
            </tr>
          </thead>
          <tbody>
            {infrastructures.map((infrastructure) => {
              const status = getInfrastructureStatusInfo(infrastructure.status);

              return (
                <tr key={infrastructure.id}>
                  <td className="fw-semibold">{infrastructure.name}</td>
                  <td>{infrastructure.typeData?.name || emptyValue}</td>
                  <td>{infrastructure.ip || emptyValue}</td>
                  <td>{masks.formatMilhar(infrastructure.vCpu || 0)}</td>
                  <td>
                    {formatGb(infrastructure.ramGb)} /{" "}
                    {formatGb(infrastructure.ramSwapGb)}
                  </td>
                  <td>{formatGb(infrastructure.diskGb)}</td>
                  <td>{infrastructure.hostData?.name || emptyValue}</td>
                  <td>
                    <span
                      className={`badge bg-${status.variant} ${getBadgeTextClass(
                        status.variant
                      )}`}
                    >
                      {status.label}
                    </span>
                  </td>
                  <td className="text-end">
                    <button type="button" className="btn btn-sm btn-light">
                      <FiMoreHorizontal />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
